import defaultValues from './default.json';
import type { LocalisationConfigWithLang } from '../types';

const config: LocalisationConfigWithLang = { ...defaultValues };

export default config;
